import { useEffect, useState } from 'react';

import { UserService } from 'services';

import { useSnackbar } from 'notistack';

import Tools from 'utils/Tools';

import { AddButton, Layout, NoData, PageTitle, Spinner, StatusChip, UserFilters } from 'components';
import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box,
} from '@mui/material';

import { EditRounded } from '@mui/icons-material';

import EditUserDialog from '../EditUserDialog';
import AddUserDialog from '../AddUserDialog';
import CanI from 'components/CanI';

const { getClients } = UserService;

const Clients = () => {
	const [clients, setClients] = useState([]);
	const [selectedClient, setSelectedClient] = useState(null);
	const [showAddForm, setShowAddForm] = useState(false);
	const [filters, setFilters] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const { enqueueSnackbar } = useSnackbar();

	const handleCloseEditDialog = () => setSelectedClient(null);

	useEffect(() => {
		if (isLoading) {
			getClients(filters)
				.then(({ data }) => {
					setClients(data);
					setIsLoading(false);
				})
				.catch((error) => {
					enqueueSnackbar(Tools.getErrorMessage(error), { variant: 'error' });
					setIsLoading(false);
				});
		}
	}, [enqueueSnackbar, filters, isLoading]);

	const handleFilters = (queryString) => {
		setFilters(queryString);
		setIsLoading(true);
	};

	return (
		<Layout>
			<PageTitle
				title="Clientes"
				actionButtons={[
					<CanI make="CLIENT_ADD">
						<AddButton onClick={() => setShowAddForm(true)} />
					</CanI>,
				]}
			/>
			<UserFilters onSearch={handleFilters} />
			{isLoading && <Spinner text="Cargando clientes" isOpen small />}
			{!isLoading && (
				<TableContainer component={Box}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Nombre</TableCell>
								<TableCell>Apellido</TableCell>
								<TableCell>ID Cont.</TableCell>
								<TableCell>Email</TableCell>
								<TableCell>Teléfono</TableCell>
								<TableCell>Estatus</TableCell>
								<TableCell>Editar</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{clients.map((client) => (
								<TableRow key={client.id}>
									<TableCell>{client.name}</TableCell>
									<TableCell>{client.lastName || '-'}</TableCell>
									<TableCell>{client.idCont || '-'}</TableCell>
									<TableCell>{client.email}</TableCell>
									<TableCell>{client.phone || '(No disponible)'}</TableCell>
									<TableCell>
										<StatusChip isEnabled={client.isEnabled} />
									</TableCell>
									<TableCell>
										<CanI make="CLIENT_EDIT">
											<IconButton size="small" onClick={() => setSelectedClient(client)}>
												<EditRounded />
											</IconButton>
										</CanI>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			{!clients.length && !isLoading && <NoData message="No hay clientes registrados" />}

			{showAddForm && (
				<AddUserDialog
					userRole="CLIENT"
					onClose={() => setShowAddForm(false)}
					onSuccess={() => setIsLoading(true)}
				/>
			)}
			{selectedClient && (
				<EditUserDialog
					onSuccess={() => setIsLoading(true)}
					user={selectedClient}
					onClose={handleCloseEditDialog}
				/>
			)}
		</Layout>
	);
};

export default Clients;
